import { Router, NavigationEnd } from '@angular/router';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IClassificacaoMercadologica, MenuOptions } from '@vip/core';
import { DropdownDirective } from '@vip/ui/dropdown';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'vip-header-desktop-menu-principal',
  templateUrl: './header-desktop-menu-principal.component.html',
  styleUrls: ['./header-desktop-menu-principal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderDesktopMenuPrincipalComponent implements OnInit {
  @Input() options: MenuOptions = [];
  @Input() departamentos: IClassificacaoMercadologica[] = [];

  @ViewChild(DropdownDirective) dropdown!: DropdownDirective;

  dropdownDepartamentosIsOpen = false;
  activeIndex: number | null = null;

  constructor(
    private router: Router,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      // eslint-disable-next-line rxjs-angular/prefer-takeuntil
      .subscribe(() => {
        this.updateActiveMenu();
      });
    this.updateActiveMenu();
  }

  itemClick(dep: IClassificacaoMercadologica): void {
    this.zone.run(() => {
      this.router.navigateByUrl(`/departamentos${dep.link}`);
      this.dropdown.close();
    });
  }

  buildUrl(item: any): string {
    const link = String(item.link || '');
    const internal = !this.isExternal(item);

    return internal && !link.startsWith('/') ? '/' + link : link;
  }

  isExternal(item: any): boolean {
    return item.internal !== 'true';
  }

  setActive(idx: number, item: any): void {
    this.activeIndex = idx;
    this.cdr.markForCheck();
  }

  getMenuOptionValue(index: number, acessor: string) {
    return this.options[index][acessor];
  }

  onMenuItemClick(menuItem: any, index: number): void {
    const link = this.getMenuOptionValue(index, 'link');

    if (typeof link === 'string') {
      const isInternal = menuItem['internal'] === 'true';
      const isOption = this.options.some((option) => option['link'] === link);

      this.activeIndex = isOption ? index : null;

      this.cdr.detectChanges();

      if (isInternal) {
        this.router.navigate([link]);
      } else {
        window.open(link, '_blank');
      }
    } else {
      this.activeIndex = null;
      this.cdr.detectChanges();
    }
  }

  private updateActiveMenu(): void {
    const curr = this.router.url.split('?')[0];

    const normalize = (p: string) => (p.startsWith('/') ? p : '/' + p);

    const idx = this.options.findIndex((o) => {
      const raw = o['link'];

      if (typeof raw !== 'string') return false;

      const link = normalize(raw);
      return curr === link || curr.startsWith(link + '/');
    });

    this.activeIndex = idx > -1 ? idx : null;
    this.cdr.markForCheck();
  }
}
